import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { style: {"flex":"1","max-height":"200px","overflow":"auto"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Upload ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_upload, _mergeProps({ "file-list": _ctx.fileList }, _ctx.getComponentProps, {
      "max-count": _ctx.max,
      multiple: _ctx.max > 1,
      capture: undefined,
      "custom-request": _ctx.beforeUpload2,
      onPreview: _ctx.handlePreview,
      onChange: _ctx.onChange
    }), {
      default: _withCtx(() => [
        (_ctx.fileList && _ctx.fileList.length < _ctx.max)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isUpload)
                ? (_openBlock(), _createBlock(_component_a_button, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadOutlined),
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["file-list", "max-count", "multiple", "custom-request", "onPreview", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.previewVisible,
      footer: null,
      "destroy-on-close": "",
      onCancel: _ctx.handleCancel
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentProps.componentName), {
          alt: "example",
          controls: "",
          style: {"width":"100%","max-width":"50vw max-height: 50vh"},
          src: _ctx.previewMedia
        }, null, 8, ["src"]))
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ]))
}